<div fxLayout="column"  fxLayoutAlign="space-around end">
    <p class="m-0">{{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_DROP_FILES_TO_UPLOAD_INSTANTLY'|translate}}</p>
    <p class="m-0 text-bold">{{'APP_PLATFORM_DOCUMENT_MANAGER.DMS_MY_DRIVE'|translate}}</p>
</div>
